import React, { useEffect, useState } from 'react';
import '../../styles/Admin/admin_editannouncement.css';
import moment from 'moment';
import { BiPen, BiCheckCircle, BiCheckDouble } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import { displaySnackbar, YesNoSelector } from '../../utilities';
import { BASE_URL } from '../../settings';
import { v4 as uuid } from 'uuid';

export default function Admin_AlumniDetail({ job_post, fetchJobPosts, fetchJobPostById }) {
    const [tab, setTab] = useState('Details');
    const [fetched_job_post, setFetchedjob_post] = useState(job_post);
    const [isUpdating, setIsUpdating] = useState(false);
    const [isHovering, setIsHovering] = useState(false);
    const [details, setDetails] = useState();
    const [email, setEmail] = useState();
    const [companyName, setCompanyName] = useState();
    const [positionName, setPositionName] = useState();
    const [count, setCount] = useState();
    const [redirectUrl, setRedirectUrl] = useState();
    const [dueDate, setDueDate] = useState(new Date());
    const [qualifications, setQualifications] = useState([]);
    const [newQualification, setNewQualification] = useState('');
    const [isAddingMore, setIsAddingMore] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // 👇️ apply a class to main top nav bar to hide it
        let mainNavBar = document.querySelector('._3drDv.MainNavBar');
        if (mainNavBar) mainNavBar.style.display = 'none';

        window.scrollTo({ top: 0, behavior: 'smooth' });

        let pathname = location.pathname.split('/');
        let id = pathname[pathname.length - 1];

        fetch(`${BASE_URL}/jobs/read`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id }),
        })
            .then(async (result) => {
                let response = await result.json();
                let the_job_post = response?.job_post;
                setFetchedjob_post(the_job_post);
                if (the_job_post) {
                    setEmail(the_job_post?.email);
                    setCompanyName(the_job_post?.companyName);
                    setPositionName(the_job_post?.positionName);
                    setCount(the_job_post?.count);
                    setRedirectUrl(the_job_post?.redirectUrl);
                    if (the_job_post?.qualifications) {
                        setQualifications(JSON.parse(the_job_post?.qualifications || '[]'));
                    }
                    setDueDate(new Date(the_job_post?.dueDate));
                    setDetails(the_job_post?.details);
                }
            })
            .catch((error) => {
                console.log(error?.message, '\n', error);
            });
    }, []);

    // 👇️ handler to add a qualification
    const addQualification = () => {
        if (
            newQualification &&
            newQualification?.length > 0 &&
            newQualification?.trim() &&
            isNaN(newQualification)
        ) {
            setQualifications([
                ...qualifications,
                {
                    uuid: uuid(),
                    name: newQualification,
                },
            ]);
            setNewQualification('');
            setIsAddingMore(false);
        }
    };

    // 👇️ handler to remove a qualification
    const removeQualification = (item) => {
        if (item) {
            let filteredQualifications = qualifications.filter(
                (the_item) => the_item?.uuid != item?.uuid
            );
            setQualifications(filteredQualifications);
        }
    };

    // 👇️ handler to update an job_post.
    const updatejob_post = () => {
        setIsUpdating(false);

        try {
            fetch(`${BASE_URL}/jobs/update`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: fetched_job_post?.uuid,
                    details,
                    email,
                    companyName,
                    positionName,
                    count,
                    redirectUrl,
                    dueDate,
                    qualifications,
                }),
            })
                .then(async (result) => {
                    let response = await result?.json();
                    if (response?.msg === null) {
                        displaySnackbar(response?.errorMsg, true, 'Ok', () => {});
                    } else {
                        console.log(response);
                        displaySnackbar(response?.msg, false, 'Ok', () => {});
                        setTimeout(() => {
                            fetchJobPosts();
                            fetchJobPostById(fetched_job_post?.uuid);
                        }, 1000);
                    }
                })
                .catch((error) => {
                    if (error?.message == 'Failed to fetch') {
                        displaySnackbar('Could not reach the servers', true, 'Ok', () => {});
                    } else {
                        displaySnackbar('Some error occured!', true, 'Ok', () => {});
                        console.log('the error:', error);
                    }
                });
        } catch (error) {
            console.log(error?.message, '\n', error);
        }
    };

    return (
        <div className='alumni-detail'>
            {/* go back button */}
            <button onClick={() => fetchJobPostById(fetched_job_post?.uuid)}>👈️ Go Back</button>

            {/* header bar */}
            <div className='alumni-detail-header-bar'>
                <div className='left'>
                    <h1>Edit job post</h1>
                </div>
                <div className='right'></div>
            </div>

            {/* job post content */}
            <div className='alumni-detail-main-content'>
                {tab === 'Details' ? (
                    <div className='details'>
                        <span className='details-sub-header'>Job Post Information</span>

                        <div className='details-content-item'>
                            <span className='title'>Actions</span>
                            {isUpdating ? (
                                <button
                                    style={{ backgroundColor: 'green' }}
                                    onClick={() => {
                                        setIsUpdating(!isUpdating);
                                        updatejob_post();
                                    }}
                                >
                                    Update
                                </button>
                            ) : (
                                <button
                                    style={{ backgroundColor: 'green' }}
                                    onClick={() => setIsUpdating(!isUpdating)}
                                >
                                    Edit
                                </button>
                            )}
                        </div>

                        <div
                            className='details-content-item'
                            style={{ cursor: 'pointer' }}
                            onMouseEnter={() => setIsHovering(true)}
                            onMouseLeave={() => setIsHovering(false)}
                        >
                            <span className='title'>
                                Details
                                {isHovering && !isUpdating && (
                                    <BiPen
                                        onClick={() => setIsUpdating(!isUpdating)}
                                        size={25}
                                        className='edit-pen'
                                    />
                                )}
                                {isUpdating && (
                                    <BiCheckDouble
                                        onClick={() => setIsUpdating(!isUpdating)}
                                        size={35}
                                        color='green'
                                        className='edit-pen'
                                    />
                                )}
                            </span>
                            {isUpdating ? (
                                <textarea
                                    type='text'
                                    name='details'
                                    placeholder='job post details'
                                    rows={10}
                                    value={details}
                                    onChange={(e) => setDetails(e.target.value)}
                                />
                            ) : fetched_job_post?.details?.length > 0 ? (
                                <p className='text about'>{fetched_job_post?.details}</p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>

                        <div className='details-content-items'>
                            <div className='details-content-item'>
                                <span className='title'>id</span>
                                {fetched_job_post?.id > 0 ? (
                                    <p className='text'>{fetched_job_post?.id}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>user id (uuid)</span>
                                {fetched_job_post?.uuid?.length > 0 ? (
                                    <p className='text'>{fetched_job_post?.uuid}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div
                                className='details-content-item'
                                style={{ cursor: 'pointer' }}
                                onMouseEnter={() => setIsHovering(true)}
                                onMouseLeave={() => setIsHovering(false)}
                            >
                                <span className='title'>
                                    Company email
                                    {isHovering && !isUpdating && (
                                        <BiPen
                                            onClick={() => setIsUpdating(!isUpdating)}
                                            size={25}
                                            className='edit-pen'
                                        />
                                    )}
                                    {isUpdating && (
                                        <BiCheckDouble
                                            onClick={() => setIsUpdating(!isUpdating)}
                                            size={35}
                                            color='green'
                                            className='edit-pen'
                                        />
                                    )}
                                </span>
                                {isUpdating ? (
                                    <input
                                        type='email'
                                        name='email'
                                        placeholder='company email'
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                ) : fetched_job_post?.email?.length > 0 ? (
                                    <p className='text'>{fetched_job_post?.email}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div
                                className='details-content-item'
                                style={{ cursor: 'pointer' }}
                                onMouseEnter={() => setIsHovering(true)}
                                onMouseLeave={() => setIsHovering(false)}
                            >
                                <span className='title'>
                                    Company name
                                    {isHovering && !isUpdating && (
                                        <BiPen
                                            onClick={() => setIsUpdating(!isUpdating)}
                                            size={25}
                                            className='edit-pen'
                                        />
                                    )}
                                    {isUpdating && (
                                        <BiCheckDouble
                                            onClick={() => setIsUpdating(!isUpdating)}
                                            size={35}
                                            color='green'
                                            className='edit-pen'
                                        />
                                    )}
                                </span>
                                {isUpdating ? (
                                    <input
                                        type='text'
                                        name='companyName'
                                        placeholder='company name'
                                        value={companyName}
                                        onChange={(e) => setCompanyName(e.target.value)}
                                    />
                                ) : fetched_job_post?.companyName?.length > 0 ? (
                                    <p className='text'>{fetched_job_post?.companyName}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div
                                className='details-content-item'
                                style={{ cursor: 'pointer' }}
                                onMouseEnter={() => setIsHovering(true)}
                                onMouseLeave={() => setIsHovering(false)}
                            >
                                <span className='title'>
                                    Required position
                                    {isHovering && !isUpdating && (
                                        <BiPen
                                            onClick={() => setIsUpdating(!isUpdating)}
                                            size={25}
                                            className='edit-pen'
                                        />
                                    )}
                                    {isUpdating && (
                                        <BiCheckDouble
                                            onClick={() => setIsUpdating(!isUpdating)}
                                            size={35}
                                            color='green'
                                            className='edit-pen'
                                        />
                                    )}
                                </span>
                                {isUpdating ? (
                                    <input
                                        type='text'
                                        name='positionName'
                                        placeholder='required position'
                                        value={positionName}
                                        onChange={(e) => setPositionName(e.target.value)}
                                    />
                                ) : fetched_job_post?.positionName?.length > 0 ? (
                                    <p className='text'>{fetched_job_post?.positionName}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div
                                className='details-content-item'
                                style={{ cursor: 'pointer' }}
                                onMouseEnter={() => setIsHovering(true)}
                                onMouseLeave={() => setIsHovering(false)}
                            >
                                <span className='title'>
                                    Employees wanted
                                    {isHovering && !isUpdating && (
                                        <BiPen
                                            onClick={() => setIsUpdating(!isUpdating)}
                                            size={25}
                                            className='edit-pen'
                                        />
                                    )}
                                    {isUpdating && (
                                        <BiCheckDouble
                                            onClick={() => setIsUpdating(!isUpdating)}
                                            size={35}
                                            color='green'
                                            className='edit-pen'
                                        />
                                    )}
                                </span>
                                {isUpdating ? (
                                    <input
                                        type='number'
                                        name='count'
                                        placeholder='required employees'
                                        value={count}
                                        onChange={(e) => setCount(e.target.value)}
                                    />
                                ) : fetched_job_post?.count?.length > 0 ? (
                                    <p className='text'>{fetched_job_post?.count}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div
                                className='details-content-item'
                                style={{ cursor: 'pointer' }}
                                onMouseEnter={() => setIsHovering(true)}
                                onMouseLeave={() => setIsHovering(false)}
                            >
                                <span className='title'>
                                    Redirect url
                                    {isHovering && !isUpdating && (
                                        <BiPen
                                            onClick={() => setIsUpdating(!isUpdating)}
                                            size={25}
                                            className='edit-pen'
                                        />
                                    )}
                                    {isUpdating && (
                                        <BiCheckDouble
                                            onClick={() => setIsUpdating(!isUpdating)}
                                            size={35}
                                            color='green'
                                            className='edit-pen'
                                        />
                                    )}
                                </span>
                                {isUpdating ? (
                                    <input
                                        type='url'
                                        name='redirectUrl'
                                        placeholder='redirect url e.g https://www.econnet.co.zw'
                                        value={redirectUrl}
                                        onChange={(e) => setRedirectUrl(e.target.value)}
                                    />
                                ) : fetched_job_post?.redirectUrl?.length > 0 ? (
                                    <p className='text'>
                                        <a href={fetched_job_post?.redirectUrl}>
                                            {fetched_job_post?.redirectUrl}
                                        </a>
                                    </p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div
                                className='details-content-item'
                                style={{ cursor: 'pointer' }}
                                onMouseEnter={() => setIsHovering(true)}
                                onMouseLeave={() => setIsHovering(false)}
                            >
                                <span className='title'>
                                    Qualifications
                                    {isHovering && !isUpdating && (
                                        <BiPen
                                            onClick={() => setIsUpdating(!isUpdating)}
                                            size={25}
                                            className='edit-pen'
                                        />
                                    )}
                                    {isUpdating && (
                                        <BiCheckDouble
                                            onClick={() => setIsUpdating(!isUpdating)}
                                            size={35}
                                            color='green'
                                            className='edit-pen'
                                        />
                                    )}
                                </span>
                                {isUpdating ? (
                                    qualifications.length > 0 ? (
                                        <ul id='qualifications'>
                                            {qualifications.map((item, index) => (
                                                <div className='qualification-item-container'>
                                                    <li
                                                        key={`qualification-#${index}-#${item?.id}`}
                                                    >
                                                        {item?.name || 'qualification'}
                                                    </li>
                                                    <span onClick={() => removeQualification(item)}>
                                                        x
                                                    </span>
                                                </div>
                                            ))}

                                            {isAddingMore && (
                                                <div className='adding-more-qualification-container'>
                                                    <input
                                                        type='text'
                                                        name='new qualification'
                                                        id='new-qualification'
                                                        placeholder='new qualification'
                                                        value={newQualification}
                                                        onChange={(e) =>
                                                            setNewQualification(e.target.value)
                                                        }
                                                    />
                                                    <button onClick={addQualification}>+</button>
                                                    <button
                                                        style={{
                                                            color: 'red',
                                                            backgroundColor: 'transparent',
                                                            border: '.1rem solid darkblue',
                                                            borderRadius: '.3rem',
                                                        }}
                                                        onClick={() => setIsAddingMore(false)}
                                                    >
                                                        x
                                                    </button>
                                                </div>
                                            )}
                                            <span
                                                className='empty-qualifications-text'
                                                onClick={() => setIsAddingMore(true)}
                                            >
                                                Add more...
                                            </span>
                                        </ul>
                                    ) : (
                                        <>
                                            {isAddingMore && (
                                                <div className='adding-more-qualification-container'>
                                                    <input
                                                        type='text'
                                                        name='new qualification'
                                                        id='new-qualification'
                                                        placeholder='new qualification'
                                                        value={newQualification}
                                                        onChange={(e) =>
                                                            setNewQualification(e.target.value)
                                                        }
                                                    />
                                                    <button onClick={addQualification}>+</button>
                                                    <button
                                                        style={{
                                                            color: 'red',
                                                            backgroundColor: 'transparent',
                                                            border: '.1rem solid darkblue',
                                                            borderRadius: '.3rem',
                                                        }}
                                                        onClick={() => setIsAddingMore(false)}
                                                    >
                                                        x
                                                    </button>
                                                </div>
                                            )}
                                            <span
                                                className='empty-qualifications-text'
                                                onClick={() => setIsAddingMore(true)}
                                            >
                                                Add some...
                                            </span>
                                        </>
                                    )
                                ) : fetched_job_post?.qualifications?.length > 0 ? (
                                    <ul className='qualifications-list'>
                                        {qualifications.map((item, index) => (
                                            <li
                                                key={`item?.uuid-#${index}`}
                                                className='qualifications-list-item'
                                            >
                                                {item?.name || `item-#${index}`}
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div
                                className='details-content-item'
                                style={{ cursor: 'pointer' }}
                                onMouseEnter={() => setIsHovering(true)}
                                onMouseLeave={() => setIsHovering(false)}
                            >
                                <span className='title'>
                                    Offer closes on
                                    {isHovering && !isUpdating && (
                                        <BiPen
                                            onClick={() => setIsUpdating(!isUpdating)}
                                            size={25}
                                            className='edit-pen'
                                        />
                                    )}
                                    {isUpdating && (
                                        <BiCheckDouble
                                            onClick={() => setIsUpdating(!isUpdating)}
                                            size={35}
                                            color='green'
                                            className='edit-pen'
                                        />
                                    )}
                                </span>
                                {isUpdating ? (
                                    <input
                                        type='date'
                                        name='dueDate'
                                        id='dueDate'
                                        placeholder='due date'
                                        value={dueDate}
                                        title='the date that this offer closes.'
                                        onChange={(e) => setDueDate(e.target.value)}
                                    />
                                ) : fetched_job_post?.dueDate?.length > 0 ? (
                                    <p className='text'>
                                        {moment(new Date(fetched_job_post?.dueDate)).calendar()}
                                    </p>
                                ) : (
                                    (<p className='empty-text'>...</p>)()
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Posted on</span>
                                {fetched_job_post?.createdAt?.length > 0 ? (
                                    <p className='text'>
                                        {moment(new Date(fetched_job_post?.createdAt)).calendar()}
                                    </p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Last updated on</span>
                                {fetched_job_post?.updatedAt?.length > 0 ? (
                                    <p className='text'>
                                        {moment(new Date(fetched_job_post?.updatedAt)).calendar()}
                                    </p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>
                        </div>
                    </div>
                ) : (
                    <h1>Conversations</h1>
                )}
            </div>
        </div>
    );
}
